export enum Variance {
    INACC_PLANNING= 'Inaccurate planning',
    PRE_WORK= 'Prerequiste work',
    DESIGN_MATTER= 'Design Matter',
    FAILED_OR_NO_IN= 'Failed or no inspection',
    LABOR_NOT_AVAI= 'Labor not available',
    MATERIAL_NOT_AV= 'Material not available',
    EQUIPMENT_NOT_AV= 'Equipment not available',
    CONTRACTS= 'Contracts',
    CHANGE_ORDER= 'Change order (C/O)',
    REQUEST_FOR_INFOR= 'Requestion for Information(RFI)',
    SUBMITTALS= 'Submittals',
    WEATHER= 'Weather',
    I_FORGOT= 'I forgot',
    UNFORSEEN_COND= 'Unforeseen conditions',
    VALUE_ENG_DELAY= 'Value engineering delay',
    LONG_ANTIC= 'Longer than anticipated',
    NO_ACCESS= 'No access',
    OTHER_PRIOR= 'Other priority work'
  }

  export const VarianceToEnglish = {
    INACC_PLANNING: 'Inaccurate planning',
    PRE_WORK: 'Prerequiste work',
    DESIGN_MATTER: 'Design Matter',
    FAILED_OR_NO_IN: 'Failed or no inspection',
    LABOR_NOT_AVAI: 'Labor not available',
    MATERIAL_NOT_AV: 'Material not available',
    EQUIPMENT_NOT_AV: 'Equipment not available',
    CONTRACTS: 'Contracts',
    CHANGE_ORDER: 'Change order (C/O)',
    REQUEST_FOR_INFOR: 'Requestion for Information(RFI)',
    SUBMITTALS: 'Submittals',
    WEATHER: 'Weather',
    I_FORGOT: 'I forgot',
    UNFORSEEN_COND: 'Unforeseen conditions',
    VALUE_ENG_DELAY: 'Value engineering delay',
    LONG_ANTIC: 'Longer than anticipated',
    NO_ACCESS: 'No access',
    OTHER_PRIOR: 'Other priority work'
  }


// WEBPACK FOOTER //
// ./src/utils/Variance.ts